module.exports = __webpack_public_path__ + "static/img/cadastrar_noticia_page.384b4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cadastrar_noticia_page.jpg
// module id = 9URH
// module chunks = 1